import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/PetServices.css";
import Sidebar from "./Sidebar";
import Header from "./Header";
import api from "../api"; // ✅ centralized api.js

// Images
import groomingImg from "../assets/grooming.png";
import walkingImg from "../assets/walking.png";
import boardingImg from "../assets/boarding.png";
import trainingImg from "../assets/training.png";
import doctorImg from "../assets/doctor_appointment.png";
import dietImg from "../assets/diet_planning.png";
import shoppingImg from "../assets/shopping.png";
import PawAnimation from "./PawAnimation";

// Default images map
const defaultImages = {
  Grooming: groomingImg,
  Walking: walkingImg,
  Boarding: boardingImg,
  Training: trainingImg,
  "Doctor Appointment": doctorImg,
  "Diet Planning": dietImg,
  Shopping: shoppingImg,
};

// Correct navigation path mapping
const serviceRoutes = {
  Grooming: "/grooming",
  Walking: "/walking",
  Boarding: "/boarding",
  Training: "/training",
  "Doctor Appointment": "/doctor_appointment",
  "Diet Planning": "/diet_plan",
  Shopping: "/shoppers-and-shop",
};

export default function PetServices() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        setError("");

        // ✅ call centralized API (token automatically added from interceptor)
        const res = await api.get("/admin/services/");

        console.log("Services API Response:", res.data);

        // Backend returns array of services: [{id, service}]
        setServices(res.data.services || res.data || []);
      } catch (err) {
        console.error("Failed to fetch services:", err);
        setError("Failed to load services.");
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  return (
    <div className="container">
      <Sidebar />
      <div className="main">
        <Header />
        <div className="main-content">
          <h3>Service</h3>

          {loading && <PawAnimation/>}
          {error && <p className="error">{error}</p>}

          <section className="cards">
            {!loading &&
              !error &&
              services.map((service) => {
                const image = defaultImages[service.service] || doctorImg;
                const path =
                  serviceRoutes[service.service] || "/doctor_appointment";

                return (
                  <Link key={service.id} to={path} className="card-link">
                    <div className="card">
                      <img
                        src={image}
                        alt={service.service}
                        className="card-image"
                      />
                      <p className="card-title">{service.service}</p>
                    </div>
                  </Link>
                );
              })}
          </section>
        </div>
      </div>
    </div>
  );
}
